import { driverAuthorizeSync, syncTerminalAuthorize,selectAuthorizeMangerPage,InsertAuthorizeTerminal,deleteTerminalAuthorize,selectAuthorizeByDriver } from "../../api/config/modules/AuthorizationManagement";

const state = {
    selectAuthorizeMangerPage: {},
    InsertAuthorizeTerminal: {},
    deleteTerminalAuthorize: {},
    selectAuthorizeByDriver: {},
    syncTerminalAuthorize: {},
    // deleteAuthorize: {},
    driverAuthorizeSync: {}
};

const mutations = {
  SET_QUERYAUTHORIZEMANGER: (state, selectAuthorizeMangerPage) => {
    state.selectAuthorizeMangerPage = selectAuthorizeMangerPage;
  },
  SET_INSERTAUTHORIZEMANGER: (state, InsertAuthorizeTerminal) => {
    state.InsertAuthorizeTerminal = InsertAuthorizeTerminal;
  },
  SET_DELETEAUTHORIZEMANGER: (state, deleteTerminalAuthorize) => {
    state.deleteTerminalAuthorize = deleteTerminalAuthorize;
  },
  SET_AUTHORIZEMANGERBYDRIVER: (state, selectAuthorizeByDriver) => {
    state.selectAuthorizeByDriver = selectAuthorizeByDriver;
  },
  SET_SYNCTERMINALAUTHORIZE: (state, syncTerminalAuthorize) => {
    state.syncTerminalAuthorize = syncTerminalAuthorize;
  },
  // SET_DELETEAUTHORIZE: (state, deleteAuthorize) => {
  //   state.deleteAuthorize = deleteAuthorize;
  // },
  SET_DRIVERAUTHORIZESYNC: (state, driverAuthorizeSync) => {
    state.driverAuthorizeSync = driverAuthorizeSync;
  },
};

const actions = {
  GET_QUERYAUTHORIZEMANGER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectAuthorizeMangerPage(data)
        .then((res) => {
          commit("SET_QUERYAUTHORIZEMANGER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTAUTHORIZEMANGER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        InsertAuthorizeTerminal(data)
        .then((res) => {
          commit("SET_INSERTAUTHORIZEMANGER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEAUTHORIZEMANGER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteTerminalAuthorize(data)
        .then((res) => {
          commit("SET_DELETEAUTHORIZEMANGER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_AUTHORIZEMANGERBYDRIVER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectAuthorizeByDriver(data)
        .then((res) => {
          commit("SET_AUTHORIZEMANGERBYDRIVER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SYNCTERMINALAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      syncTerminalAuthorize(data)
        .then((res) => {
          commit("SET_SYNCTERMINALAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // GET_DELTEAUTHORIZE: ({ commit }, data) => {
  //   return new Promise((resolve, reject) => {
  //     deleteAuthorize(data)
  //       .then((res) => {
  //         commit("SET_DELTEAUTHORIZE", res);
  //         resolve(res);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },
  GET_DRIVERAUTHORIZESYNC: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      driverAuthorizeSync(data)
        .then((res) => {
          commit("SET_DRIVERAUTHORIZESYNC", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
